import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import { auth } from './auth.module';
import getters from './getters'
import state from './state'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  // state: {
  // },
  // mutations: {
  // },
  // actions: {
  // },
  state,
  mutations,
  actions,
  getters,
  modules: {
    auth
  },
  plugins: [createPersistedState()],
})
